import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import BsInfoCircleFill from "../../../assets/icons/info";
import { loginSchema } from "../../../utils/validationSchemas";
import { successMsg } from "../../../utils/toastMessage";
import { getMyAccountPagePath, handleLoginPop } from "../../../utils/helpers";
import { resetPasswordRoute, signinRoute, signupRoute } from "../../../routes/routesPath";
import { handleApiRequest } from "../../../services/handleApiRequest";
import { login } from "../../../redux/auth/thunk";
import SocialGoogleLogin from "../socialLogin/googleLogin";
import SideSection from "../components/sideSection";
import AppLogo from "../../../Component/appLogo";
import MyHelmet from "../../../seo/helmet";
import Asterik from "../../../Component/common/asterik";
import { PasswordInput, TextInput } from "../../../Component/formComponent/components/inputFields";
import { ErrorField } from "../../../Component/common/errorField";

export default function Signin({ loginFromPop }) {
  const navigate = useNavigate();
  const { rememberedUser } = useSelector((state) => state.auth);

  const handleLogin = async () => {
    const response = await handleApiRequest(login, { ...values, loginType: "normal" });

    if (response.status) {
      successMsg("Login Success!!");
      if (loginFromPop) {
        handleLoginPop(false);
      } else {
        navigate(getMyAccountPagePath());
      }
    }
  };

  const { values, errors, touched, handleChange, handleSubmit, isSubmitting, setSubmitting } =
    useFormik({
      initialValues: { email: "", password: "", remember: false, ...(rememberedUser || {}) },
      enableReinitialize: true,
      validationSchema: loginSchema,
      onSubmit: handleLogin,
    });

  return (
    <>
      <MyHelmet
        title={"Join to connect with emotional support community"}
        keywords={[]}
        description="Feelinghub is an anonymous social platform to share feelings online or post life stories anonymously for free. It is a safe space to express yourself."
        link={signinRoute}
      />

      <section className="position-relative">
        <div className="">
          <Row className={`authContainer m-0 ${loginFromPop ? "h-auto" : ""}`}>
            {!loginFromPop && <SideSection />}
            <Col
              lg={!loginFromPop ? 5 : 12}
              className={`authFormContainer px-3 ${loginFromPop ? "pb-3" : "py-5"}`}>
              <div className="w-100">
                <AppLogo />
                <div className="position-relative mt-3 w-100">
                  <Form className="" onSubmit={handleSubmit}>
                    <div className="position-relative my-3">
                      <label htmlFor="email" className="text-color mb-1">
                        Email
                        <Asterik />
                      </label>

                      <TextInput
                        type="email"
                        placeholder="Enter Email Address"
                        name="email"
                        value={values.email}
                        onChange={handleChange}
                      />
                      <ErrorField error={touched.email ? errors.email : ""} />
                    </div>

                    <div className="my-2 mt-3">
                      <div className=" d-flex align-items-center gap-3 w-100">
                        <label htmlFor="loginPassword" className="text-color hstack gap-2 mb-1">
                          <span>
                            Password
                            <Asterik />
                          </span>

                          <BsInfoCircleFill
                            className="pointer"
                            data-tooltip-id="tooltip"
                            data-tooltip-content="Use 8 or more characters with a mix of letters, numbers & symbols"
                          />
                        </label>
                      </div>

                      <PasswordInput
                        id="loginPassword"
                        name="password"
                        value={values.password}
                        onChange={handleChange}
                      />
                      <ErrorField error={touched.password ? errors.password : ""} />
                    </div>

                    <div className="mb-2 pt-1 d-flex justify-content-between align-items-lg-center">
                      <div className="hstack">
                        <input
                          type="checkbox"
                          id="remember"
                          className="rememberMe me-1 shadow-none"
                          name="remember"
                          checked={values.remember}
                          onChange={handleChange}
                        />
                        <label htmlFor="remember" className="text-color">
                          Remember Me
                        </label>
                      </div>
                      <p className="mb-0">
                        <span
                          onClick={() => {
                            handleLoginPop(false);
                          }}>
                          <Link to={resetPasswordRoute} className="text-decoration-none">
                            Forgot Password?
                          </Link>
                        </span>
                      </p>
                    </div>

                    {isSubmitting ? (
                      <button
                        className="secondaryBtn muted rounded w-100 d-flex align-items-center justify-content-center mt-4 py-1"
                        disabled>
                        Getting your Details
                        <div className="growLoader spinner-grow ms-2" role="status" />
                      </button>
                    ) : (
                      <button type="submit" className="primaryBtn rounded w-100 mt-4 py-1">
                        Login
                      </button>
                    )}
                  </Form>

                  <h4 className="text-center my-3 font-monospace">OR</h4>

                  <SocialGoogleLogin isSubmitting={isSubmitting} setSubmitting={setSubmitting} />
                  <div className="medium mt-3">
                    <p className="mb-0">
                      Don't have an account?
                      <span
                        onClick={() => {
                          handleLoginPop(false);
                        }}>
                        <Link to={signupRoute} className="text-decoration-none">
                          {" "}
                          Create
                        </Link>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>
    </>
  );
}
